import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#3D3935] py-12 px-4 text-center" data-id="element-82">
      <div className="max-w-3xl mx-auto" data-id="element-83">
        <h2 className="text-[#F5C84B] font-black text-2xl tracking-widest uppercase mb-4" data-id="element-84">
          💛 ITERAPRO™
        </h2>
        <p className="text-[#8B7E76] font-medium text-sm sm:text-base mb-8 max-w-md mx-auto" data-id="element-85">
          Recursos que ayudan a enseñar mejor y acompañar con más herramientas.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-8 text-[#EFE3D4] font-semibold text-sm" data-id="element-86">
          <a href="mailto:soporte.iterapro@gmail.com" className="hover:text-[#F5C84B] transition-colors" data-id="element-87">
            📧 soporte.iterapro@gmail.com
          </a>
          <a href="#" className="hover:text-[#F5C84B] transition-colors" data-id="element-88">
            📲 @iterapro.ok
          </a>
        </div>

        <div className="border-t border-[#8B7E76]/30 pt-8" data-id="element-89">
          <p className="text-[#8B7E76] text-xs font-medium" data-id="element-90">
            © IteraPro™ 2026 — Todos los derechos reservados.
          </p>
          <div className="mt-4 flex justify-center gap-4 text-[#8B7E76] text-xs" data-id="element-91">
            <a href="#" className="hover:text-[#EFE3D4] transition-colors" data-id="element-92">
              Términos y Condiciones
            </a>
            <span data-id="element-93">|</span>
            <a href="#" className="hover:text-[#EFE3D4] transition-colors" data-id="element-94">
              Políticas de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}